import { SET_VALUE_ROUTING } from '../../../actions/travelKe/routing';
import { routingRules } from './routing';
import {
    TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE,
    TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID,
} from '../../../actions/travelKe/personalDetails';
import { travelDetailsFormRules } from './travelDetails';

import {
    MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALUE,
    MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALID,
} from '../../../actions/travelKe/motorAgentModal';
import { agentModaleFormRules } from './agentModal';

import { TRAVEL_INSURANCE_FORM_SET_VALID, TRAVEL_INSURANCE_FORM_SET_VALUE } from '../../../actions/travelKe/quote';
import { quoteFormRules } from './quote';
import { PAYMENTS_SET_VALID, PAYMENTS_SET_VALUE } from '../../../actions/travelKe/payments';
import { paymentsFormRules } from './payments';

export const travelKeRules = (store, next, action) => {
    if (
        action.type.startsWith(TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE) ||
        action.type.startsWith(TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALID)
    ) {
        return travelDetailsFormRules(store, next, action);
    }
    if (action.type.startsWith(SET_VALUE_ROUTING)) {
        return routingRules(store, next, action);
    }

    if (action.type.startsWith(PAYMENTS_SET_VALUE) || action.type.startsWith(PAYMENTS_SET_VALID)) {
        return paymentsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALUE) ||
        action.type.startsWith(MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALID)
    ) {
        return agentModaleFormRules(store, next, action);
    }

    if (
        action.type.startsWith(TRAVEL_INSURANCE_FORM_SET_VALUE) ||
        action.type.startsWith(TRAVEL_INSURANCE_FORM_SET_VALID)
    ) {
        return quoteFormRules(store, next, action);
    }

    // if (action.type.startsWith(SET_SHARE_EMAIL_VALUE) || action.type.startsWith(SET_SHARE_EMAIL_VALID)) {
    // 	return shareQuoteFormRules(store, next, action);
    // }

    return null;
};
